var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
            'loading-placeholder': true,
            'image-loading-placeholder': true,
        },style:({
            width: _vm.styleWidth,
            height: _vm.styleHeight,
            borderRadius: _vm.circle ? '50% !important' : null,

         })},[_vm._v(" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }